import { Slide } from "react-reveal";
import g1 from "../../assets/images/gallery/f11.jpg";
import g2 from "../../assets/images/gallery/f8.jpg";
import g3 from "../../assets/images/gallery/f13.jpg";
import g4 from "../../assets/images/gallery/f14.jpg";
import g5 from "../../assets/images/gallery/f5.jpg";

const HomeGalleryShow = () => {
  return (
    <section className="homeGallery section-spacing-80 whitedot-bg">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="section-head width-600">
              <Slide top>
                <h2 className="section-title big-title">
                  <span className="flexi-green">Professional Painters</span> in
                  Kampala, Uganda
                </h2>
              </Slide>
            </div>
            <div className="section-body">
              <ul className="gallery">
                <li className="gallery-item">
                  <figure>
                    <img src={g1} alt="Flexi Painters Portfolio" />
                    <figcaption>Flexi Painters</figcaption>
                  </figure>
                </li>
                <li className="gallery-item">
                  <figure>
                    <img src={g2} alt="Flexi Painters Portfolio" />
                    <figcaption>Flexi Painters</figcaption>
                  </figure>
                </li>
                <li className="gallery-item tall">
                  <figure>
                    <img src={g5} alt="Flexi Painters Portfolio" />
                    <figcaption>Flexi Painters</figcaption>
                  </figure>
                </li>
                <li className="gallery-item">
                  <figure>
                    <img src={g4} alt="Flexi Painters Portfolio" />
                    <figcaption>Flexi Painters</figcaption>
                  </figure>
                </li>
                <li className="gallery-item">
                  <figure>
                    <img src={g3} alt="Flexi Painters Portfolio" />
                    <figcaption>Flexi Painters</figcaption>
                  </figure>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeGalleryShow;
